<template>
  <b-row>

    <b-col cols="12">
      <label class="mb-2 mr-2">
        <span slot="label-text">
          Show this variable only if this variable is true:
        </span>
      </label>
    </b-col>
    <b-col cols="12">
      <b-btn
        size="sm"
        variant="danger"
        class="mt-2"
        @click="conditionSelectorVisible = !conditionSelectorVisible"
      >
        Add Question
      </b-btn>
    </b-col>
      <b-col
        cols="12"
        v-if="conditionSelectorVisible"
      >
        <anualize-variable-selector
          :condition="condition"
          :question="question"
          @set-visibility-condition="
            $emit('set-visibility-condition', $event)
          "
        />
      </b-col>
      <b-col cols="12" class="mt-3" v-if="selectedVariable">
        <VariableDisplay :variable="selectedVariable">
          <b-col
            slot="remove-icon"
            cols="1"
            class="d-flex align-items-center justify-content-center"
          >
            <i
              class="mdi mdi-close-circle-outline size-medium phairify-color-red"
              @click="removeVariable(selectedVariable.id)"
            />
          </b-col>
        </VariableDisplay>
      </b-col>
    </b-row>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import { CONDITION_VARIANTS } from '@/store';
import AnualizeVariableSelector from '@/components/question/variable/AnualizeVariableSelector';
import cloneDeep from 'lodash/cloneDeep';
import VariableDisplay from '@/components/VariableDisplay';
import { GET_CONDITION_VARIABLES_ACTION } from '@/store/conditionVariables';

export default {
  name: 'VisibilityAnualizeForm',
  components: {
    AnualizeVariableSelector,
    VariableDisplay
  },
  props: {
    question: Object,
    condition: Object
  },
  data: function () {
    return {
        conditionSelectorVisible: false,
        variable: cloneDeep(...this.question.variables),
        primaryPickList:[]
    };
  },
  computed: {
    visibilityValidationCondition: function () {
      return this.variable && Array.isArray(this.variable.condition)
        ? this.variable.condition.find(
            (cond) => cond.variant === CONDITION_VARIANTS.VISIBILITY
          )
        : null;
    },
    responseValidationCondition: function () {
      return this.variable && Array.isArray(this.variable.condition)
        ? this.variable.condition.find(
            (cond) => cond.variant === CONDITION_VARIANTS.RESPONSE_VALIDATION
          )
        : null;
    },
    variables: function () {
      return this.$store.getters.variablesVisibilityConditionItems;
    },
    selectedVariable: function () {
      return this.primaryPickList.find(({ id }) => id === this.question.annualized_question);
      //return this.variables.find(({ id }) => id === this.question.annualized_question);
    }
  },
  methods: {
    removeVariable: function (variableId) {
      this.$emit('unset-annualize-question-variable', variableId);
    },
    loadVariables: async function () {
      this.$wait.start(this.loaderName);
      try {
        this.primaryPickList = await this.$store.dispatch(
          GET_CONDITION_VARIABLES_ACTION
        );
      } catch (e) {
        this.$toasted.error('Unable to upload variables for conditions', {
          duration: 3000,
        });
      } finally {
        this.$wait.end(this.loaderName);
      }
    },
  },
  created: function () {
    this.loadVariables();
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
@import '../../../../sass/variables_mixins';
.variable-select-for-condition {
  .list-group-item-action {
    color: inherit !important;
    &:hover,
    &:focus-visible {
      background-color: $light-blue;
    }
  }
  i.mdi.mdi-close-circle-outline {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
